import Header from './components/Header'
import Links from './components/Links'
import Footer from './components/Footer'
import sections from './data/sections.json'
import profile from './data/profile.json'
import useLocalStorage from 'use-local-storage'
import toggleThemeWhite from './assets/images/darkModeToggleOff.svg'
import toggleThemeDark from './assets/images/darkModeToggleOn.svg'

function App() {
  const defaultDark = window.matchMedia('(prefers-color-scheme: dark)').matches
  const [theme, setTheme] = useLocalStorage(
    'theme',
    defaultDark ? 'dark' : 'light'
  )

  const isDarkMode = theme === 'dark'
  const themeToggle = isDarkMode ? toggleThemeDark : toggleThemeWhite

  const switchTheme = () => {
    setTheme(isDarkMode ? 'light' : 'dark')
  }

  return (
    <div className='app' data-theme={theme}>
      <div className='content'>
        <button className='toggleBtn' onClick={switchTheme}>
          <img src={themeToggle} alt='' />
        </button>
        <Header profile={profile} isDarkModeOn={isDarkMode} />
        <Links sections={sections} />
      </div>
      <Footer />
    </div>
  )
}

export default App
